import React, { useState } from "react";
// react component for creating dynamic tables
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
//import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import ReactBSAlert from "react-bootstrap-sweetalert";
import { useHistory } from "react-router-dom";
import ToolkitProvider, {
  Search,
  CSVExport,
} from "react-bootstrap-table2-toolkit";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import GetApp from "@material-ui/icons/GetApp";
import CardHeader from "@material-ui/core/CardHeader";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";

import KeyboardArrowDown from "@material-ui/icons/KeyboardArrowDown";
import FormGroup from "@material-ui/core/FormGroup";
import FormLabel from "@material-ui/core/FormLabel";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";

// @material-ui/lab components
// @material-ui/icons components
// core components
import Snackbar from "components/Snackbar/Snackbar.js";
import componentStyles from "assets/theme/views/admin/react-bs-table.js";
import btnComponentStyles from "assets/theme/components/button.js";
import LoadingAnimation from "components/Animations/loading";
import Slide from "@material-ui/core/Slide";
import { useAsyncEffect } from "use-async-effect";
import { redirectToLogout,isSaudi } from "common/SharedFn";
import { getUserAddresses,getAllCities,updateUserAddress,deleteUserAddress } from "../../network/ApiAxios";
import { ArrowBack,Edit,Delete} from "@material-ui/icons";

const useStyles = makeStyles(componentStyles);
const useStylesButtons = makeStyles(btnComponentStyles);
const createHistory = require("history").createBrowserHistory;

const pagination = paginationFactory({
  page: 1,
  alwaysShowAllBtns: true,
  showTotal: true,
  withFirstAndLast: false,
  sizePerPageRenderer: ({ onSizePerPageChange }) => (
    <div className="dataTables_length" id="datatable-basic_length">
      <label>
        Show{" "}
        {
          <select
            name="datatable-basic_length"
            aria-controls="datatable-basic"
            className="form-control form-control-sm"
            onChange={(e) => onSizePerPageChange(e.target.value)}
          >
            <option value="10">10</option>
            <option value="25">25</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </select>
        }{" "}
        entries.
      </label>
    </div>
  ),
});

const { SearchBar } = Search;

const { ExportCSVButton } = CSVExport;

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});
    
const UserAddressesTable = (props) => {
  const classes = { ...useStyles(), ...useStylesButtons() };
  const [alert, setAlert] = React.useState(false);
  const componentRef = React.useRef(null);
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState("");
  const [notifMessage, setNotifMessage] = useState("");
  const [showError, setShowError] = React.useState(false);
  const [success, setSuccess] = React.useState(false);
  const [updateModal, setUpdateModal] = useState(false);
  const [name, setName] = useState("");
  const [flat, setFlat] = useState("");
  const [house, setHouse] = useState("");
  const [road, setRoad] = useState("");
  const [districtName, setDistrictName] = useState("");
  const [shortAddress, setShortAddress] = useState("");
  const [block, setBlock] = useState("");
  const [coordinates, setCoordinates] = useState("");
  const [instructions, setInstructions] = useState("");
  const [type, setType] = useState("");
  const [city, setCity] = useState(0);
  const [id, setId] = useState();
  const [executeUpdate, setExecuteUpdate] = useState(false);
  const [executeDelete, setExecuteDelete] = useState(false);
  const [forceRefresh, setForceRefresh] = useState(false);
  const [cities, setCities] = useState([]);
  var currentUserId = props.match.params.id;
  let history = useHistory();

  const warningAlert = (title,message,action) => {
    setAlert(
      <ReactBSAlert
        warning
        style={{ display: "block", marginTop: "-100px" }}
        title={title}
        onConfirm={action}
        onCancel={() => setAlert(null)}
        showCancel="true"
        cancelBtnBsStyle="warning"
        cancelBtnText="No"
        confirmBtnBsStyle="success"
        confirmBtnText="Yes"
        btnSize=""
        confirmBtnStyle={{
          marginRight: undefined,
          borderColor: undefined,
          boxShadow: undefined,
        }}
        cancelBtnStyle={{
          marginRight: undefined,
          borderColor: undefined,
          boxShadow: undefined,
        }}
      >
        {message}
      </ReactBSAlert>
    );
  };

  const showSuccessNotification = (message) => {
    setNotifMessage(message);
    setSuccess(true);
    setTimeout(function () {
      setSuccess(false);
    }, 3000);
  };

  const showErrorNotification = (message) => {
    setNotifMessage(message);
    setShowError(true);
    setTimeout(function () {
      setShowError(false);
    }, 3000);
  };


  const setCurrentRecord = (info) => {
    const { id,name,flat,house,road,districtName,shortAddress,block,type,city,instructions,coordinates} = info;
    setName(name);
    setFlat(flat);
    setHouse(house); 
    setRoad(road);
    setDistrictName(districtName);
    setShortAddress(shortAddress);
    setBlock(block);
    setType(type);
    setCity(city);
    setInstructions(instructions);
    setCoordinates(coordinates);
    setId(id);
  };

  const clearCurrentRecord = () => {
    setName("");
    setFlat("");
    setHouse(""); 
    setRoad("");
    setDistrictName("");
    setShortAddress("");
    setBlock("");
    setType("");
    setCity();
    setInstructions("");
    setCoordinates("");
    setId();
  };

  const fetchAddresses = async () => {
    setForceRefresh(false);
    setIsLoading(true);
    try{
    const response = await getUserAddresses(currentUserId);
    const { data } = response;
    const responseCities = await getAllCities();
    if (data.result.isSuccess) {
      setCities(responseCities.data.data);
      setData(data.data.map((prop) => makeTableRow(prop,responseCities.data.data)));
      //setError("");
    } else {
      showErrorNotification(data.result.description);
      if(data.result.code == -2){
        redirectToLogout();
      }
    }
    }
    catch(ex){
      showErrorNotification("Failed to fetch addresses");
    }
    setIsLoading(false);
  };

  const deleteParam = async () => {
    setExecuteDelete(false);
    setIsLoading(true);
    try{
    const response = await deleteUserAddress(id);
    const { data } = response;
    if (data.result.isSuccess) {
      showSuccessNotification("Address Deleted Successfully");
      setUpdateModal(false);
      setForceRefresh(true);      
    } else {
      showErrorNotification(data.result.description);
      setIsLoading(false);
    }
    }
    catch(ex){
      showErrorNotification("Failed to delete address");
      setIsLoading(false);
    }
  };


  const updateAddressAction = async () => {
    setExecuteUpdate(false);
    setIsLoading(true);
    try{
    const response = await updateUserAddress(id,name,flat,house,road,districtName,shortAddress,block,type,city,instructions,coordinates);
    const { data } = response;
    if (data.result.isSuccess) {
      showSuccessNotification("Address Updated Successfully");
      setUpdateModal(false);
      setForceRefresh(true);      
    } else {
      showErrorNotification(data.result.description);
      setIsLoading(false);
    }
    }
    catch(ex){
      showErrorNotification("Failed to update address");
      setIsLoading(false);
    }
  };


  useAsyncEffect(async () => {
    if(executeUpdate){
      updateAddressAction();
    }
    else if(executeDelete){
      deleteParam();
    }
    else{
      fetchAddresses();
    }
      
    
  }, [forceRefresh,executeDelete,executeUpdate]);

  const makeTableRow = (info,cities) => {
    for (var i=0; i < cities.length; i++) {
      if(cities[i].id == info.city){
        info.cityText = cities[i].cityEn;
        break;
      }
    }
    return {
      ...info,
      actions: (
        <div className="actions-right">
          <Tooltip title="Edit">
            <Button size="small" 
                  classes={{
                    root: classes.buttonContainedWarning,
                  }} 
                  variant="contained" 
                  style={{ marginLeft: "5px" }}
                  onClick={() => {
                    clearCurrentRecord();
                setCurrentRecord(info);
                setUpdateModal(true);
            }}>
              <Box component={Edit} />
            </Button>
          </Tooltip>
          <div style={{ display: "inline-block" }}>
          <Tooltip title="Delete">
                <Button
                  size="small"
                  classes={{
                    root: classes.buttonContainedError,
                  }}
                  variant="contained"
                  style={{ marginLeft: "5px" }}
                  onClick={() => {warningAlert("Delete Address","Are you sure you would like to delete the address with id "+info.id+"?",async () =>  {
                    setCurrentRecord(info);
                    setAlert(null);
                    setExecuteDelete(true);
                  })}}
                >
                  <Box component={Delete} />
                </Button>
              </Tooltip>
              </div> 
        </div>
      ),
    };
  };

  return (
    <>
      {alert}
      {/* Page content */}
      <Container
        maxWidth={false}
        component={Box}
        marginTop="-4.5rem"
        classes={{ root: classes.containerRoot }}
      >

        <Grid container>
          <Grid item xs={12}>
            <Card elevation={0}>

              <div style={{width: "100%"}}>
              <ToolkitProvider
                data={data}
                keyField="id"
                columns={[
                  {
                    dataField: "id",
                    text: "ID",
                    sort: true,
                    style: {'whiteSpace': 'normal'}
                  },
                  {
                    dataField: "name",
                    text: "Name",
                    sort: true,
                    style: {'whiteSpace': 'normal'}
                  },
                  {
                    dataField: "flat",
                    text: "Flat",
                    sort: true,
                    style: {'whiteSpace': 'normal'}
                  },
                  {
                    dataField: "house",
                    text: "House/Hotel/Building",
                    sort: true,
                    style: {'whiteSpace': 'normal'}
                  },
                  {
                    dataField: "road",
                    text: "Road",
                    sort: true,
                    style: {'whiteSpace': 'normal'}
                  },
                  {
                    dataField: "districtName",
                    text: "District Name",
                    sort: true,
                    headerStyle: isSaudi() ? {} : {display : "none"},
                    style : isSaudi() ? {} : {display : "none"},
                    csvExport: isSaudi()
                  },
                  {
                    dataField: "block",
                    text: "Block",
                    sort: true,
                    style: {'whiteSpace': 'normal'}
                  },
                  {
                    dataField: "cityText",
                    text: "City",
                    sort: true,
                    style: {'whiteSpace': 'normal'}
                  },
                  {
                    dataField: "shortAddress",
                    text: "Short Address",
                    sort: true,
                    headerStyle: isSaudi() ? {} : {display : "none"},
                    style : isSaudi() ? {} : {display : "none"},
                    csvExport: isSaudi()
                  },
                  {
                    dataField: "type",
                    text: "Type",
                    sort: true,
                    style: {'whiteSpace': 'normal'}
                  },
                  {
                    dataField: "instructions",
                    text: "Instructions",
                    sort: true,
                    style: {'whiteSpace': 'normal'}
                  },
                  {
                    dataField: "coordinates",
                    text: "Coordinates",
                    sort: true,
                    style: {'whiteSpace': 'normal'}
                  },
                  {
                    dataField: "actions",
                    classes: "actions-col",
                    headerClasses: "actions-col",
                    text: "Actions",
                    csvExport: false,
                  },
                ]}
                search
                exportCSV
              >
                {(props) => (
                                    <>
                  <CardHeader
                    style={{ paddingTop: "0.875rem", paddingBottom: "0.875rem" }}
                    title={
                      <>
                    <Box
                      component={Typography}
                      variant="h2"
                      marginBottom="0!important"
                    >
                      <Tooltip title="Back">
            <Button size="small" 
                  classes={{
                    root: classes.buttonContainedPrimary,
                  }} 
                  variant="contained" 
                  style={{ marginRight: "20px" }}
                  onClick={() => {
                    history.goBack();
            }}>
              <Box component={ArrowBack} />
            </Button>
          </Tooltip>
                      <Box component="span">User ID #{currentUserId} Addressses</Box>
                    </Box>
                      </>
                    }
                    action={
                      <Box
                        display="flex" alignItems="center" flexWrap="wrap"
                        justifyContent="flex-end"
                        style={{ gap: 8, marginTop: 8, marginRight: 8 }}
                      >
                        <div
                          id="datatable-basic_filter"
                          style={{ display: "flex", alignItems: "center", height: 40 }}
                        >
                          <SearchBar
                            className="form-control-sm"
                            placeholder="Search..."
                            style={{ height: 40, margin: 0, boxSizing: "border-box" }}
                            {...props.searchProps}
                          />
                        </div>
                        <Tooltip title="Download CSV">
                          <span style={{ display: "flex" }}>
                            <ExportCSVButton
                              className="MuiButtonBase-root"
                              style={{
                                width: 40, height: 40, padding: 0,
                                display: "flex", alignItems: "center", justifyContent: "center",
                                border: "1px solid #172b4d", borderRadius: 8,
                                color: "#fff", backgroundColor: "#172b4d", cursor: "pointer",
                              }}
                              {...props.csvProps}
                            >
                              <GetApp style={{ width: 18, height: 18 }} />
                            </ExportCSVButton>
                          </span>
                        </Tooltip>
                      </Box>
                    }
                  />
                  <div className="table-responsive">
                    <BootstrapTable
                      ref={componentRef}
                      {...props.baseProps}
                      bootstrap4={true}
                      pagination={pagination}
                      bordered={true}
                      striped={true}
                      //filter={ filterFactory() }
                      noDataIndication={() =>
                        isLoading ? (
                          <Box
                            component={Grid}
                            container
                            justifyContent="center"
                            className="justify-content-center"
                          >
                            <div
                              className="text-center"
                              style={{ width: "20%" }}
                            >
                              <LoadingAnimation />{" "}
                            </div>
                          </Box>
                        ) : (
                          <h4>No Records</h4>
                        )
                      }
                      id="main-table"
                    />
                    
                  </div>
                                      </>
                )}
              </ToolkitProvider>
              </div>
            </Card>
          </Grid>
        </Grid>
        <Dialog
          classes={{
            root: classes.center + " " + classes.modalRoot,
            paper: classes.modal + " " + classes.modalSmall,
          }}
          open={updateModal && !isLoading}
          TransitionComponent={Transition}
          keepMounted
          onClose={() => setUpdateModal(false)}
        >
          <DialogTitle disableTypography className={classes.modalHeader}>
            <h4 className={classes.modalTitle}>Update Address</h4>
          </DialogTitle>
          <DialogContent
            className={classes.modalBody + " " + classes.modalSmallBody}
          >
            <form>
                  <FormGroup>
                    <FormLabel>Name</FormLabel>
                    <OutlinedInput
                      fullWidth
                      type="text"
                      placeholder="Address name"
                      value={name ?? ""}
                      onChange={(e) => setName(e.target.value)}
                    />
                  </FormGroup>

                  <FormGroup>
                    <FormLabel>Flat</FormLabel>
                    <OutlinedInput
                      fullWidth
                      type="text"
                      placeholder="Flat"
                      value={flat ?? ""}
                      onChange={(e) => setFlat(e.target.value)}
                    />
                  </FormGroup>

                  <FormGroup>
                    <FormLabel>Building/House</FormLabel>
                    <OutlinedInput
                      fullWidth
                      type="text"
                      placeholder="Building/House"
                      value={house ?? ""}
                      onChange={(e) => setHouse(e.target.value)}
                    />
                  </FormGroup>

                  <FormGroup>
                    <FormLabel>Road</FormLabel>
                    <OutlinedInput
                      fullWidth
                      type="text"
                      placeholder="Road"
                      value={road ?? ""}
                      onChange={(e) => setRoad(e.target.value)}
                    />
                  </FormGroup>
                  
                { isSaudi() ? (
                <FormGroup>
                  <FormLabel>District Name</FormLabel>
                  <OutlinedInput
                    fullWidth
                    type="text"
                    placeholder="District Name"
                    value={districtName ?? ""}
                    onChange={(e) => setDistrictName(e.target.value)}
                  />
                </FormGroup>) : ('')
                }
                  <FormGroup>
                    <FormLabel>Block</FormLabel>
                    <OutlinedInput
                      fullWidth
                      type="text"
                      placeholder="Block"
                      value={block ?? ""}
                      onChange={(e) => setBlock(e.target.value)}
                    />
                  </FormGroup>

                  <FormGroup>
                    <FormLabel>City</FormLabel>
                    <FormControl variant="outlined" fullWidth>
                      <Select
                        value={city}
                        onChange={(e) => setCity(e.target.value)}
                        IconComponent={KeyboardArrowDown}
                      >
                        {cities.map(function (city, i) {
                          return (
                            <MenuItem value={city.id}>{city.cityEn}</MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                  </FormGroup>

                  { isSaudi() ? (
                <FormGroup>
                  <FormLabel>Short Address</FormLabel>
                  <OutlinedInput
                    fullWidth
                    type="text"
                    placeholder="Short Address"
                    value={shortAddress ?? ""}
                    onChange={(e) => setShortAddress(e.target.value)}
                  />
                </FormGroup>) : ('')
                }
                  <FormGroup>
                    <FormLabel>Address Type</FormLabel>
                    <FormControl variant="outlined" fullWidth>
                      <Select
                        value={type}
                        onChange={(e) => setType(e.target.value)}
                        IconComponent={KeyboardArrowDown}
                      >
                        <MenuItem value={"Villa"}>Villa</MenuItem>
                        <MenuItem value={"Apt"}>Apt</MenuItem>
                        <MenuItem value={"Hotel"}>Hotel</MenuItem>
                      </Select>
                    </FormControl>
                  </FormGroup>

                  <FormGroup>
                    <FormLabel>Address Instructions</FormLabel>
                    <OutlinedInput
                      fullWidth
                      type="text"
                      placeholder="Address Instructions"
                      value={instructions ?? ""}
                      onChange={(e) =>
                        setInstructions(e.target.value)
                      }
                    />
                  </FormGroup>

                  <FormGroup>
                    <FormLabel>Location Coordintaes</FormLabel>
                    <OutlinedInput
                      fullWidth
                      type="text"
                      placeholder="XX.XXXXXX,XX.XXXXXX"
                      value={coordinates ?? ""}
                      onChange={(e) =>
                        setCoordinates(e.target.value)
                      }
                    />
                  </FormGroup>
            </form>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setUpdateModal(false)}>Cancel</Button>
            <Button
              onClick={() => updateAddressAction()}
              classes={{
                root: classes.buttonContainedPurple100,
              }}
              variant="contained"
            >
              Update
            </Button>
          </DialogActions>
        </Dialog>
        <Snackbar
          place="tr"
          color="success"
          // icon={AddAlert}
          message={notifMessage}
          open={success}
          closeNotification={() => setSuccess(false)}
          close
        />

        <Snackbar
          place="tr"
          color="rose"
          // icon={AddAlert}
          message={notifMessage}
          open={showError}
          closeNotification={() => setShowError(false)}
          close
        />
      </Container>
    </>
  );
};

export default UserAddressesTable;
